import React from 'react'

export default function NotFound() {
  return (
    <h1>Error 404 - Page Not Found</h1>
  )
}
